import { useEffect, useState } from 'react'
import { getClient, urlFor } from '../client'
import type { SanityImageSource } from '@sanity/image-url'

export type NewsArticle = {
  title: string
  publishedAt?: string
  image?: SanityImageSource
  body?: unknown[]
}

const QUERY = `*[_type == "newsArticle" && slug.current == $slug][0]`

export function useNewsArticle(slug: string | undefined) {
  const [article, setArticle] = useState<NewsArticle | null>(null)

  useEffect(() => {
    if (slug) {
      getClient().fetch<NewsArticle>(QUERY, { slug }).then(setArticle)
    }
  }, [slug])

  const articleImageUrl = article?.image ? (urlFor(article.image)?.width(550).height(310).url() ?? null) : null

  return { article, articleImageUrl }
}
